
<template>
<div>
  <chc-header :noLogin="true"></chc-header>
  <navbar :noLogin="true"></navbar>
  <section v-if="state == 'prospect'">
    <div class="field">
      <h1>Thank you for your interest in Cars Helping Charities</h1>
      <p>Fill out the form below to gain access to our Charity Preview account, where you can preview the tools and reports provided by Cars Helping Charities for our associated charities.</p>
    </div>
    <div class="field">
      <chc-input v-model="data.name" type="text" label="Charity Name" :required="true" :error="errors.name"></chc-input>
      <chc-input v-model="data.address_street" type="text" label="Mailing Address" :error="errors.address_street"></chc-input>
      <chc-input v-model="data.address_city" type="text" label="City" :error="errors.address_city"></chc-input>
      <chc-input v-model="data.address_state" label="State" format="combo"
        :autoCompleteValues="$store.state.constants.us_states_list" :error="errors.address_state"></chc-input>
      <chc-input v-model="data.address_zip" type="text" label="Zip" :error="errors.address_zip"></chc-input>
      <chc-input v-model="data.contacts.main.first_name" type="text" label="Main Contact First Name" :required="true" :error="errors['contacts.main.first_name']"></chc-input>
      <chc-input v-model="data.contacts.main.last_name" type="text" label="Main Contact Last Name" :required="true" :error="errors['contacts.main.last_name']"></chc-input>
      <chc-input v-model="data.contacts.main.title" type="text" label="Main Contact Title" :error="errors['contacts.main.title']"></chc-input>
      <chc-input v-model="data.contacts.main.phone" type="text" label="Main Contact Phone Number" :required="true" :error="errors['contacts.main.phone']"></chc-input>
      <chc-input v-model="data.contacts.main.email" type="text" label="Main Contact Email" :required="true" :error="errors['contacts.main.email']"></chc-input>
      <chc-input v-model="data.website" type="text" label="Website Address" :error="errors.website"></chc-input>
    </div>
    <div class="field buttons">
      <input type="submit" class="btn" value="Submit" @click="submit">
    </div>
  </section>
  <section v-if="state == 'submitted'">
    <div class="field">
      <h1>Thank you for your interest in Cars Helping Charities</h1>
      <p>Pleas check your email for more information on accessing the Preview Account.</p>
    </div>
  </section>
</div>
</template>

<script>
import ChcHeader from '@/components/ChcHeader'
import Navbar from '@/components/Navbar'
import store from '@/store'

export default {
  name: 'CharityProspect',
  data () {
    return {
      // prospect or submitted
      state: 'prospect',
      data: {
        contacts: {
          main: {}
        }
      },
      errors: {},
    }
  },
  props: [],
  beforeRouteEnter (to, from, next) {
    Promise.all([
      store.dispatch('syncConstants'),
    ]).then(() => next())
  },
  methods: {
    submit () {
      store.functions.charity.createCharityProspect(this.data, (error) => {
        this.errors = error
      }).then(() => {
        this.state = 'submitted'
      })
    },
  },
  components: {
    ChcHeader,
    Navbar
  }
}
</script>

<style scoped>
section {
    margin-top: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/CharityProspect.vue